import { useContext } from 'react'
import {
  AuthContext,
  AuthContextProps,
} from '../containers/contexts/auth/AuthContext'

const useAuth = () => {
  return useContext(AuthContext) as AuthContextProps
}

export default useAuth
